import { Dialog } from "primereact/dialog";
import { useDispatch, useSelector } from "react-redux";
import { setIsEditProfilePopupOpen } from "src/redux/slices/bMCProfileSlice";
import RegistrationForm from "../Registration/registration";
import { useTranslation } from "react-i18next";
const EditProfile = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common"]);

  const { isEditProfilePopupOpen } = useSelector(
    (state: any) => state.bMCProfile
  );

  const handleEditProfile = () => {
    dispatch(setIsEditProfilePopupOpen(false) as any);
    // reset to original data on server
    // dispatch(getBMCProfile() as any);
  };

  return (
    <Dialog
      visible={isEditProfilePopupOpen}
      onHide={handleEditProfile}
      header={t("updateProfile")}
      headerClassName="popup-header"
      className="edit-profile-popup"
    >
      <RegistrationForm isEditMode={true} />
    </Dialog>
  );
};

export default EditProfile;
